"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*
Note: I'm not proud of this solution, but I was not able to have a variable inside useDataApi to remember the callback. It was random 'undefined', with this solution it works.
*/

/**
 * Set a callback that is triggered after we handle a request. This allows custom logic in your application to handle a specific statuscode on all api calls
 * @param {function} callback (statuscode, response)
 */
var state = {
  onHandleStatus: null
};
var _default = state;
exports["default"] = _default;